/**
 * @module geo/actions/helpers
 * @hidden
 *
 */
import { promiseActionCreator } from "../../helpers/observable.to.promise";
import { TypeKeyActions } from "../types.key.action";
import { TypeKeyActionsProxy } from "../types.key.actions.proxy";

import actionCreatorFactory, {
  ActionCreator,
  AsyncActionCreators
} from "./fsa";

/**
 * @hidden
 * @private
 * @type {ActionCreatorFactory}
 */
export const actionCreator = actionCreatorFactory();
/**
 * Helper to build the 3 actionCreators for one action type
 * @internal
 * @private
 * @hidden
 */
export function actionCreatorsBuilder<T, R, E>(
  typeKey: TypeKeyActions | TypeKeyActionsProxy
): [ActionCreator<T>, AsyncActionCreators<T, R, E>, any] {
  const aC = actionCreator<T>(typeKey) as ActionCreator<T>;
  const assyncAC = actionCreator.async<T, R, E>(typeKey);
  return [
    aC,
    assyncAC,
    promiseActionCreator(aC, [assyncAC.done.type, assyncAC.failed.type])
  ];
}
